import { useEffect, useState } from 'react';
import useAxios from './useAxios';

const useLensOrders = ({ options, ...axiosConfig } = {}) => {

  const [{ data, error, loading }, getLensOrders] = useAxios({ url: '/lens-orders', ...axiosConfig }, options);

  const [lensOrders, setLensOrders] = useState([]);

  const [total, setTotal] = useState(0);

  const [size, setSize] = useState(0);

  const [numberOfPages, setNumberOfPages] = useState(0);

  useEffect(() => {
    if (data) {
      setLensOrders(data.data);
      setTotal(data?.meta?.total);
      setSize(data?.meta?.per_page);
      setNumberOfPages(data.meta?.last_page);
    }

  }, [data, loading, error]);

  return [{ lensOrders, total, numberOfPages, size, error, loading }, getLensOrders];
};

export default useLensOrders;